import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { ISignalsWebhookSubscription } from "../../types/row-data";
import { webhookSubscriptionsQueryKeys } from "../key-factory/factory";

export default function useGetWebhookSubscriptions(): UseQueryResult<ISignalsWebhookSubscription[]> {
    return useQuery({
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: webhookSubscriptionsQueryKeys.list(),
        refetchOnMount: "always",
        gcTime: 0,
        queryFn({ signal }) {
            return salesApiService.management.getWebhookSubscriptionsList({ cancellation: signal });
        },
    });
}
